import * as React from 'react';
import { DisplayNumber, DisplayNumberProps } from 'ui/display-number/display-number';
import styles from './display-number-unit-of-measure.scss';
import { Label } from 'ui';

export const DisplayNumberUnitOfMeasure = (props: DisplayNumberProps) => {
  const {className} = props;
  const propClone = {...props, className: styles.number};
  return <div id={props.componentId} className={`${className} ${styles.numberWithUnit}`}>
    <Label label={props.label} classNames="label" />
    <div className={styles.container}>
      <DisplayNumber {...propClone} label={{ ...props.label, visible: false }} />
      <span className={styles.unit}>{props.children}</span>
    </div>
  </div>;
  };
